import { History, Shuffle, Sparkles } from "lucide-react";
import { useState } from "react";
import { PageHeader } from "../components/layout/PageHeader";
import { AliasesTab } from "../components/recommendations/AliasesTab";
import { QueriesTab } from "../components/recommendations/QueriesTab";
import { RunsTab } from "../components/recommendations/RunsTab";

type Tab = "queries" | "aliases" | "runs";

const tabs: { id: Tab; label: string; icon: typeof Sparkles }[] = [
	{ id: "queries", label: "Queries", icon: Sparkles },
	{ id: "aliases", label: "Aliases", icon: Shuffle },
	{ id: "runs", label: "Runs", icon: History },
];

const Recommendations = () => {
	const [activeTab, setActiveTab] = useState<Tab>("queries");

	return (
		<div className="space-y-6">
			<PageHeader
				kicker="Menu · Recommendations"
				title="Recommendations."
				qualifier="What search pins first."
				description="Curate what the storefront pins to the top of search results. Only approved entries are served."
			/>

			<div className="border-b border-slate-200">
				<nav className="flex gap-1" aria-label="Tabs">
					{tabs.map((tab) => (
						<button
							key={tab.id}
							type="button"
							onClick={() => setActiveTab(tab.id)}
							className={`flex items-center gap-2 border-b-2 px-5 py-3 text-sm font-medium transition-all ${
								activeTab === tab.id
									? "border-primary text-primary"
									: "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700"
							}`}
						>
							<tab.icon className="h-4 w-4" />
							{tab.label}
						</button>
					))}
				</nav>
			</div>

			{activeTab === "queries" && <QueriesTab />}
			{activeTab === "aliases" && <AliasesTab />}
			{activeTab === "runs" && <RunsTab />}
		</div>
	);
};

export default Recommendations;
